import axios from 'axios';
import { cachetime } from '../config';

export default function() {
  return {
    namespaced: true,
    state: {
      tag: {},
    },
    mutations: {
      SET_TAG(state, { data, locale, tagId }) {
        state.tag[`${locale}/${tagId}`] = {
            data,
            __updatedAt: Date.now()
        }
      },
    },
    actions: {
      FETCH_TAG({ state, commit }, { locale, tagId }) {
        const now = Date.now();
        if(state.video_playlists) {
            if(now - state.video_playlists.__updatedAt < cachetime) {
                return;
            }
        }
        
        return axios.get(encodeURI(`/api/tag/${tagId}`))
          .then((res) => {
            const data = res.data || {};
            commit('SET_TAG', { data, locale, tagId });
          }).catch(err => {
            console.log(err);
            throw err;
          });
      },
    },
    getters: {
      getTag: (state) => (locale, tagId) => {
        return state.tag[`${locale}/${tagId}`];
      },
    }
  }
}